import { Mitarbeiter, Projekt, Zuweisung, Abwesenheit } from '../types'

export const mitarbeiter: Mitarbeiter[] = [
  // Konstruktion (5)
  {
    id: 'm1',
    name: 'M. Schmidt',
    abteilung: 'Konstruktion',
    skills: ['CAD', 'SolidWorks'],
    verfuegbarkeit: 100,
    email: 'm.schmidt@firma.de',
    telefon: '123',
  },
  {
    id: 'm2',
    name: 'K. Weber',
    abteilung: 'Konstruktion',
    skills: ['CAD', 'Projektleitung'],
    verfuegbarkeit: 100,
    email: 'k.weber@firma.de',
    telefon: '124',
  },
  {
    id: 'm3',
    name: 'T. Müller',
    abteilung: 'Konstruktion',
    skills: ['CAD', 'Hydraulik'],
    verfuegbarkeit: 80,
    email: 't.mueller@firma.de',
    telefon: '125',
  },
  {
    id: 'm4',
    name: 'A. Fischer',
    abteilung: 'Konstruktion',
    skills: ['CAD', 'Statik'],
    verfuegbarkeit: 100,
    email: 'a.fischer@firma.de',
    telefon: '126',
  },
  {
    id: 'm5',
    name: 'S. Becker',
    abteilung: 'Konstruktion',
    skills: ['CAD', 'Dokumentation'],
    verfuegbarkeit: 50,
    email: 's.becker@firma.de',
    telefon: '127',
  },

  // E-Konstruktion (3)
  {
    id: 'm6',
    name: 'J. Wagner',
    abteilung: 'E-Konstruktion',
    skills: ['EPLAN', 'SPS'],
    verfuegbarkeit: 100,
    email: 'j.wagner@firma.de',
    telefon: '128',
  },
  {
    id: 'm7',
    name: 'P. Hoffmann',
    abteilung: 'E-Konstruktion',
    skills: ['EPLAN', 'Schaltschrank'],
    verfuegbarkeit: 100,
    email: 'p.hoffmann@firma.de',
    telefon: '129',
  },
  {
    id: 'm8',
    name: 'L. Schulz',
    abteilung: 'E-Konstruktion',
    skills: ['EPLAN', 'Sicherheitstechnik'],
    verfuegbarkeit: 100,
    email: 'l.schulz@firma.de',
    telefon: '130',
  },

  // Montage (5)
  {
    id: 'm9',
    name: 'R. Koch',
    abteilung: 'Montage',
    skills: ['Mechanik', 'Schweißen'],
    verfuegbarkeit: 100,
    email: 'r.koch@firma.de',
    telefon: '131',
  },
  {
    id: 'm10',
    name: 'D. Richter',
    abteilung: 'Montage',
    skills: ['Mechanik', 'Hydraulik'],
    verfuegbarkeit: 100,
    email: 'd.richter@firma.de',
    telefon: '132',
  },
  {
    id: 'm11',
    name: 'F. Wolf',
    abteilung: 'Montage',
    skills: ['Elektrik', 'Verdrahtung'],
    verfuegbarkeit: 100,
    email: 'f.wolf@firma.de',
    telefon: '133',
  },
  {
    id: 'm12',
    name: 'H. Schäfer',
    abteilung: 'Montage',
    skills: ['Mechanik', 'Vorarbeiter'],
    verfuegbarkeit: 100,
    email: 'h.schaefer@firma.de',
    telefon: '134',
  },
  {
    id: 'm13',
    name: 'B. Neumann',
    abteilung: 'Montage',
    skills: ['Mechanik'],
    verfuegbarkeit: 100,
    email: 'b.neumann@firma.de',
    telefon: '135',
  },

  // Einkauf (1)
  {
    id: 'm14',
    name: 'C. Zimmermann',
    abteilung: 'Einkauf',
    skills: ['SAP', 'Verhandlung'],
    verfuegbarkeit: 100,
    email: 'c.zimmermann@firma.de',
    telefon: '136',
  },

  // Inbetriebnahme (1)
  {
    id: 'm15',
    name: 'E. Braun',
    abteilung: 'Inbetriebnahme',
    skills: ['SPS', 'Reisebereitschaft'],
    verfuegbarkeit: 100,
    email: 'e.braun@firma.de',
    telefon: '137',
  },
]

export const projekte: Projekt[] = [
  {
    id: 'p1',
    projektnummer: 'P-2026-001',
    name: 'Abfüllanlage Typ X',
    kunde: 'Brauerei Müller',
    startKw: 1,
    endKw: 20,
    status: 'Aktiv',
    farbe: '#3B82F6',
    phase: 'Konstruktion',
  },
  {
    id: 'p2',
    projektnummer: 'P-2026-002',
    name: 'Verpackungslinie V3',
    kunde: 'PackCo GmbH',
    startKw: 5,
    endKw: 25,
    status: 'Aktiv',
    farbe: '#10B981',
    phase: 'Konzept',
  },
  {
    id: 'p3',
    projektnummer: 'P-2026-003',
    name: 'Förderband System',
    kunde: 'LogiTech AG',
    startKw: 10,
    endKw: 30,
    status: 'Aktiv',
    farbe: '#F59E0B',
    phase: 'Planung',
  },
  {
    id: 'p4',
    projektnummer: 'P-2026-004',
    name: 'Montageautomat M7',
    kunde: 'AutoParts KG',
    startKw: 2,
    endKw: 15,
    status: 'Aktiv',
    farbe: '#8B5CF6',
    phase: 'Montage',
  },
  {
    id: 'p5',
    projektnummer: 'P-2026-005',
    name: 'Prüfstand Hydraulik',
    kunde: 'HydroTest GmbH',
    startKw: 12,
    endKw: 28,
    status: 'Pausiert',
    farbe: '#14B8A6',
    phase: 'Wartend',
  },
]

export const zuweisungen: Zuweisung[] = [
  // P1 - Abfüllanlage (KW 1-20)
  {
    id: 'z1',
    mitarbeiterId: 'm1',
    projektId: 'p1',
    phase: 'Konstruktion',
    startKw: 1,
    endKw: 8,
    auslastungProzent: 100,
  },
  {
    id: 'z2',
    mitarbeiterId: 'm2',
    projektId: 'p1',
    phase: 'Review',
    startKw: 6,
    endKw: 8,
    auslastungProzent: 50,
  },
  {
    id: 'z3',
    mitarbeiterId: 'm6',
    projektId: 'p1',
    phase: 'E-Planung',
    startKw: 4,
    endKw: 10,
    auslastungProzent: 100,
  },
  {
    id: 'z4',
    mitarbeiterId: 'm9',
    projektId: 'p1',
    phase: 'Montage',
    startKw: 10,
    endKw: 18,
    auslastungProzent: 100,
  },

  // P2 - Verpackungslinie (KW 5-25)
  {
    id: 'z5',
    mitarbeiterId: 'm2',
    projektId: 'p2',
    phase: 'Konstruktion',
    startKw: 9,
    endKw: 16,
    auslastungProzent: 100,
  },
  {
    id: 'z6',
    mitarbeiterId: 'm7',
    projektId: 'p2',
    phase: 'E-Planung',
    startKw: 10,
    endKw: 18,
    auslastungProzent: 100,
  },
  {
    id: 'z7',
    mitarbeiterId: 'm10',
    projektId: 'p2',
    phase: 'Montage',
    startKw: 18,
    endKw: 24,
    auslastungProzent: 100,
  },

  // P3 - Förderband (KW 10-30)
  {
    id: 'z8',
    mitarbeiterId: 'm3',
    projektId: 'p3',
    phase: 'Konstruktion',
    startKw: 10,
    endKw: 15,
    auslastungProzent: 100,
  },
  {
    id: 'z9',
    mitarbeiterId: 'm8',
    projektId: 'p3',
    phase: 'E-Planung',
    startKw: 14,
    endKw: 20,
    auslastungProzent: 100,
  },

  // P4 - Montageautomat (KW 2-15)
  {
    id: 'z10',
    mitarbeiterId: 'm4',
    projektId: 'p4',
    phase: 'Konstruktion',
    startKw: 2,
    endKw: 8,
    auslastungProzent: 100,
  },
  {
    id: 'z11',
    mitarbeiterId: 'm11',
    projektId: 'p4',
    phase: 'Montage',
    startKw: 8,
    endKw: 14,
    auslastungProzent: 100,
  },

  // Overbooking Example: m1 assigned to P1 (KW 1-8) and P4 (KW 2-8) - Conflict!
  {
    id: 'z12',
    mitarbeiterId: 'm1',
    projektId: 'p4',
    phase: 'Support',
    startKw: 4,
    endKw: 6,
    auslastungProzent: 50,
  },
]

export const abwesenheiten: Abwesenheit[] = [
  { id: 'a1', mitarbeiterId: 'm1', typ: 'Urlaub', startKw: 12, endKw: 13 },
  { id: 'a2', mitarbeiterId: 'm5', typ: 'Krank', startKw: 3, endKw: 4 },
  { id: 'a3', mitarbeiterId: 'm9', typ: 'Urlaub', startKw: 20, endKw: 22 },
]
